"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolbarAdvancedFilter = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const AdvancedFilter_1 = require("../../AdvancedFilter");
function toolbarAdvancedFilter({ valueTitle, filtersTitle, decorators, disabled, groups, texts }) {
    return {
        decorators,
        disabled,
        render: (model, { disabled }) => {
            return (react_1.default.createElement(core_1.ModelRenderer, { model: model, render: ({ value: { filters } }) => {
                    const columns = [];
                    const values = [];
                    groups.forEach(({ items, groupId = '', property }) => {
                        items.forEach((item) => {
                            const filterValue = filters.getFilterValue({
                                property,
                                groupId
                            });
                            if (Array.isArray(filterValue) &&
                                filterValue.includes(item.value)) {
                                values.push({
                                    value: item.value,
                                    property,
                                    groupId
                                });
                            }
                        });
                    });
                    groups.map(({ columnIndex = 0, groupId = '', property, title, items }) => {
                        var _a;
                        if (!((_a = columns[columnIndex]) === null || _a === void 0 ? void 0 : _a.groups)) {
                            columns[columnIndex] = { groups: [] };
                        }
                        columns[columnIndex].groups.push({
                            title: title,
                            items: items.map(({ value, title, testId, icon }) => ({
                                value: { value, property, groupId },
                                label: title,
                                iconSrc: icon,
                                testId: testId
                            }))
                        });
                    });
                    return (react_1.default.createElement(AdvancedFilter_1.AdvancedFilter, { label: valueTitle, value: values, options: {
                            header: filtersTitle,
                            cols: columns
                        }, disabled: disabled, onChange: (value) => {
                            const separator = '|:|';
                            const nextGroupedValues = value.reduce((acc, curr) => {
                                const key = `${curr.property}${separator}${curr.groupId}`;
                                if (!acc[key]) {
                                    acc[key] = [];
                                }
                                acc[key].push(curr);
                                return acc;
                            }, {});
                            groups.forEach(({ groupId = '', property, operation = core_1.FILTER_OPERATION.in, collation = core_1.FILTER_COLLATION.ignorecase }) => {
                                const key = `${property}${separator}${groupId}`;
                                const nextItems = nextGroupedValues[key];
                                if (!nextItems || !nextItems.length) {
                                    model.setFilter({ property, groupId }, null);
                                    return;
                                }
                                model.setFilter({ property, groupId }, {
                                    operation,
                                    collation,
                                    value: nextItems.map((i) => i.value)
                                });
                            });
                        }, texts: texts }));
                } }));
        }
    };
}
exports.toolbarAdvancedFilter = toolbarAdvancedFilter;
//# sourceMappingURL=toolbarAdvancedFilter.js.map